import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-save-design-dialog',
  templateUrl: './save-design-dialog.component.html',
  styleUrls: ['./save-design-dialog.component.scss']
})
export class SaveDesignDialogComponent implements OnInit {

  saveForm = new UntypedFormGroup({
    saveas: new UntypedFormControl('', Validators.required)
  })
  saveas: string;

  constructor(
    private fb: UntypedFormBuilder,
    private dialogRef: MatDialogRef<SaveDesignDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data) {
    this.saveas = data.saveas;
  }

  ngOnInit() {
    // this.form = this.fb.group({
    //   saveas: [this.saveas, []]
    // });
  }

  save() {
    this.dialogRef.close(this.saveForm.value);
  }

  close() {
    this.dialogRef.close();
  }
}